// One definition of the scheme chip, used by the certificates tab, the
// verification queue and the users list.
//
// It has to accept two key spaces: the slug stored on a subscription
// (section-6-domestic), and the raw value the registration form puts on
// targetScheme (s6Domestic) - an applicant has no subscription to read a slug
// from until verification creates one.

export type SchemeChip = {
	letter: string;
	label: string;
	classes: string;
};

const DOMESTIC: SchemeChip = { letter: "D", label: "Domestic", classes: "bg-blue-100 text-blue-700" };
const NON_DOMESTIC: SchemeChip = { letter: "N", label: "Non-Dom", classes: "bg-amber-100 text-amber-700" };
const ADVANCED: SchemeChip = { letter: "A", label: "Advanced", classes: "bg-purple-100 text-purple-700" };
const CPD: SchemeChip = { letter: "C", label: "CPD", classes: "bg-teal-100 text-teal-700" };

const CHIPS: Record<string, SchemeChip> = {
	"section-6-domestic": DOMESTIC,
	s6Domestic: DOMESTIC,

	"section-6-non-domestic": NON_DOMESTIC,
	s6NonDomestic: NON_DOMESTIC,

	"section-6-non-domestic-advanced": ADVANCED,
	s6NonDomesticAdv: ADVANCED,

	"cpd-membership": CPD,
	cpd: CPD,
	CPD: CPD,
};

// Anything unrecognised gets a neutral mark rather than silently claiming a scheme.
const UNKNOWN: SchemeChip = { letter: "?", label: "Unknown", classes: "bg-gray-100 text-gray-600" };

export const schemeChip = ( scheme?: string | null ): SchemeChip =>
	CHIPS[String( scheme ?? "" )] ?? UNKNOWN;

// Distinct chips for someone who may hold several subscriptions, in a stable
// order so the same person does not shuffle between renders.
export const schemeChips = ( schemes: ( string | null | undefined )[] ): SchemeChip[] => {
	const seen = new Set<string>();
	const out: SchemeChip[] = [];

	for ( const s of schemes ) {
		if ( !s ) continue;

		const chip = schemeChip( s );

		if ( seen.has( chip.letter ) ) continue;

		seen.add( chip.letter );
		out.push( chip );
	}

	return out;
};
